import React from 'react';
import PropTypes from 'prop-types';
import {RouteWithSubRoutes} from '../utils/router-utils';
import {Switch} from 'react-router';
import {Redirect} from 'react-router-dom';
import Header from './header';

export const CoreLayout = ({routes}) => (
    <div>
        <Header/>
        <div className="app-content grid">
            <div className="container">
                <Switch>
                    {routes.map((route, i) => (<RouteWithSubRoutes key={i} {...route}/>))}
                    <Redirect to="/app"/>
                </Switch>
            </div>
        </div>
    </div>
);
CoreLayout.propTypes = {
    children: PropTypes.node
};

export default CoreLayout;



// WEBPACK FOOTER //
// ./src/js/layout/core-layout.jsx